export const checkAuthorByDefault = (state: unknown[] | undefined): boolean => {
  if (!state) {
    return true
  }

  return state.length === 1 && state[0] === 'author'
}
